export const OnShipmentCreated = 0;
export const OnTurvoShipmentUpdated = 1;
export const OnOrderGroupUpdated = 2;
export const OnOrderExported = 3;
export const OnImportFinished = 4;

